var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCentre(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9334 23.7998V5.13314C21.9334 4.5143 21.6876 3.92081 21.25 3.48322C20.8124 3.04564 20.2189 2.7998 19.6001 2.7998H7.93343C7.31459 2.7998 6.7211 3.04564 6.28352 3.48322C5.84593 3.92081 5.6001 4.5143 5.6001 5.13314V23.7998M21.9334 23.7998H5.6001M21.9334 23.7998H16.1001M5.6001 23.7998H11.4334M16.1001 23.7998V17.9665C16.1001 17.6571 15.9772 17.3603 15.7584 17.1415C15.5396 16.9227 15.2429 16.7998 14.9334 16.7998H12.6001C12.2907 16.7998 11.9939 16.9227 11.7751 17.1415C11.5563 17.3603 11.4334 17.6571 11.4334 17.9665V23.7998M16.1001 23.7998H11.4334M10.2668 7.46647H11.4334M10.2668 12.1331H11.4334M16.1001 7.46647H17.2668M16.1001 12.1331H17.2668",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCentre);
export default __webpack_public_path__ + "static/media/centre.259176af3eaf429a9608c73fd4118f9a.svg";
export { ForwardRef as ReactComponent };